import { Row, Col } from 'react-bootstrap';
import { FieldWrapper, RadioFieldGroup } from 'components/form';
import { InfoBox } from 'components/info-box';
import { QuestionnaireBackButton } from 'components/questionnaire-back-button';
import { QuestionnaireNextButton } from 'components/questionnaire-next-button';

import { useFormContext } from 'react-hook-form';
import { QuestionContainer, QuestionContainerWhite, QuestionNumber } from '../../styles';

import questions from '../../../utils/MOT-questions-answers.json';
import popupTextData from '../../../utils/midlife-mot-info-pop-up-text.json';

export const QuestionTwelve = () => {
    const { data } = popupTextData;
    const popupText = data.find(item => item.question === 'wealth_question1');

    const { data: questionsData } = questions;
    const question = questionsData.find(item => item.question === '12');

    const options = questionsData.map((item: any) => {
        const options = [];
        for (let i = 1; i <= 5; i++) {
            const label = item[`answerValue${i}`];
            const value = item[`answerLabel${i}`];
            if (label && value) {
                options.push({ label, value });
            }
        }
        return options.reverse();
    });
    const {
        control,
        formState: { dirtyFields },
    } = useFormContext();
    return (
        <>
            <QuestionContainer>
                <Row>
                    <Col>
                        <QuestionNumber>Question 12 of 18</QuestionNumber>
                    </Col>
                </Row>
            </QuestionContainer>
            <QuestionContainerWhite>
                <QuestionContainer>
                    <Row>
                        <Col>
                            <FieldWrapper label={question!.questionText}>
                                <InfoBox content={popupText!.QuestionInfoButtonText} />
                                <RadioFieldGroup stacked name="wealth1" options={options[11]} />
                            </FieldWrapper>

                            <Row className="justify-content-between flex-column flex-md-row" style={{ marginTop: 25 }}>
                                <QuestionnaireBackButton route={'/about-wealth'} />
                                <QuestionnaireNextButton
                                    defaultValue={control._defaultValues.wealth1}
                                    dirtyFields={dirtyFields.wealth1}
                                    route={'/question-thirteen'}
                                />
                            </Row>
                        </Col>
                    </Row>
                </QuestionContainer>
            </QuestionContainerWhite>
        </>
    );
};
